import { useRef, useEffect } from "react";
import { Runtime, Inspector } from "@observablehq/runtime";
import notebook from "@laotzunami/dichotomy-pyramid";
import './dic.css'
function DichotomyPyramid() {
  const canvas1Ref = useRef();
  const viewofDropdownRef = useRef();

  useEffect(() => {
    const runtime = new Runtime();
    runtime.module(notebook, name => {
      if (name === "canvas1") return new Inspector(canvas1Ref.current);
      if (name === "viewof dropdown") return new Inspector(viewofDropdownRef.current);

    });
   
    return () => runtime.dispose();
  }, [canvas1Ref,viewofDropdownRef]);


  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-center">
      <div className="card bg-dark" style={{margin:'auto'}}>
          <div className="card-body">
            <p className="card-text fw-bolder" style={{color: 'yellow', fontWeight:'900'}}>Similar Traits</p>
          </div>
      </div>
      <div className="card" style={{margin:'auto',backgroundColor:'#66FF99'}}>
          <div className="card-body">
            <p className="card-text" style={{color: 'black', fontWeight:'900'}}>Different Traits</p>
          </div>
      </div>
      </div>
      
      
      <div className='pyra d-flex py-4' ref={canvas1Ref} />
      <div ref={viewofDropdownRef} />
      <p>Credit: <a href="https://observablehq.com/@laotzunami/dichotomy-pyramid">Dichotomy Pyramid by Lao</a></p>
    </div>
  );
}

export default DichotomyPyramid;